export const PERMISSION_PARTICIPANT_VIEW_ALL_ID = '5f7e1d4b5b92f176a8e5db1c';

export const ACTIVITY_ADD = {
    _id: '5f6e4d9c9a2c4a001f4f6f5c',
    name: 'Activity Add',
    scope: 'Activity',
    actions: ['Add'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Create a new activity',
};

export const ACTIVITY_VIEW = {
    _id: '5f6e4d9c9a2c4a001f4f6f5d',
    name: 'Activity View',
    scope: 'Activity',
    actions: ['View'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Access activities assigned to the user',
};

export const ACTIVITY_VIEW_ALL = {
    _id: '5f6e4d9c9a2c4a001f4f6f5e',
    name: 'Activity View All',
    scope: 'Activity',
    actions: ['ViewAll'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Access all activities belongs to the center',
};

export const ACTIVITY_EDIT = {
    _id: '5f6e4d9c9a2c4a001f4f6f5f',
    name: 'Activity Edit',
    scope: 'Activity',
    actions: ['Edit'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Update activity',
};

export const ACTIVITY_DELETE = {
    _id: '5f6e4d9c9a2c4a001f4f6f60',
    name: 'Activity Delete',
    scope: 'Activity',
    actions: ['Delete'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Delete an activity',
};
export const ACTIVITY_SCHEDULE = {
    _id: '5f6e4d9c9a2c4a001f4f6f61',
    name: 'Activity Schedule',
    scope: 'Activity',
    actions: ['Schedule'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Create a schedule in an activity',
};

export const ACTIVITY_MANAGE = {
    _id: '5f6e4d9c9a2c4a001f4f6f62',
    name: 'Activity Manage',
    scope: 'Activity',
    actions: ['*'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
};

export const PERMISSION_ACTIVITY_ALL = [
    ACTIVITY_VIEW,
    ACTIVITY_VIEW_ALL,
    ACTIVITY_ADD,
    ACTIVITY_EDIT,
    ACTIVITY_DELETE,
    ACTIVITY_SCHEDULE,
];

export const ACTIVITY_SURVEY_ADD = {
    _id: '5f6e1d9c9a2c4a001f4f6f62',
    name: 'Activity Survey Add',
    scope: 'Activity',
    actions: ['SurveyAdd'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Add surveys to be used in an activity',
};

export const ACTIVITY_SURVEY_DELETE = {
    _id: '5f6e2d9c9a2c4a001f4f6f62',
    name: 'Activity Survey Delete',
    scope: 'Activity',
    actions: ['SurveyDelete'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Delete surveys from an activity',
};

export const ACTIVITY_SURVEY_VIEW_RESPONSES = {
    _id: '5f6e3d9c9a2c4a001f4f6f62',
    name: 'Activity Survey View Responses',
    scope: 'Activity',
    actions: ['SurveyViewResponses'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'View individual survey responses within an activity',
};

export const ACTIVITY_SURVEY_SHARE = {
    _id: '5f6e5d9c9a2c4a001f4f6f62',
    name: 'Activity Survey Share',
    scope: 'Activity',
    actions: ['SurveyShare'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Open survey share view of an activity',
};

export const ACTIVITY_SURVEY_SEND_EMAIL = {
    _id: '5f6e6d9c9a2c4a001f4f6f62',
    name: 'Activity Survey Sent Emails',
    scope: 'Activity',
    actions: ['SurveySendEmail'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Share a survey with a user or a participant within an activity',
};

export const ACTIVITY_SURVEY_FILL = {
    _id: '5f6e7d9c9a2c4a001f4f6f62',
    name: 'Activity Survey Fill',
    scope: 'Activity',
    actions: ['SurveyFill'],
    effect: 'Allow',
    resources: ['*'],
    active: true,
    system: false,
    description: 'Fill a survey shared with a user or a participant within an activity',
};
